import { CIcon } from '~/icons/types'

export const ciPrinter: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M20 7.25h-.28c.02-.082.03-.166.03-.25V5A2.747 2.747 0 0 0 17 2.25H7A2.748 2.748 0 0 0 4.25 5v2c0 .084.01.168.03.25H4A2.748 2.748 0 0 0 1.25 10v7A2.748 2.748 0 0 0 4 19.75h2.25v.05a1.976 1.976 0 0 0 2 1.95h7.5a1.976 1.976 0 0 0 2-1.95v-.05H20A2.748 2.748 0 0 0 22.75 17v-7A2.747 2.747 0 0 0 20 7.25Zm-14 0A.248.248 0 0 1 5.75 7V5A1.25 1.25 0 0 1 7 3.75h10A1.25 1.25 0 0 1 18.25 5v2a.247.247 0 0 1-.25.25H6ZM16.25 19.8a.476.476 0 0 1-.5.45h-7.5a.475.475 0 0 1-.5-.45v-2.4a1.707 1.707 0 0 1 1.75-1.65h5a1.708 1.708 0 0 1 1.75 1.65v2.4ZM19 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'printer',
  type: 'solid'
}
